import { Platform, type ViewStyle } from 'react-native';
import { layout, type WebLayout } from '../constants/layout';
import { spacing } from '../constants/spacing';
import { contentMaxWidthFor, webContentMaxWidthFor } from './responsiveLayout';

export function isWebPlatform(): boolean {
  return (Platform.OS as string) === 'web';
}

export function webMaxWidthFor(webLayout: WebLayout, width?: number): number | undefined {
  if (isWebPlatform()) {
    return webContentMaxWidthFor(webLayout);
  }
  if (width != null) {
    return contentMaxWidthFor(webLayout, width);
  }
  switch (webLayout) {
    case 'form':
      return layout.webFormMaxWidth;
    default:
      return undefined;
  }
}

export const webPointer: ViewStyle = isWebPlatform()
  ? ({ cursor: 'pointer' } as ViewStyle)
  : {};

export function webShellStyle(): ViewStyle {
  return {
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
    alignItems: 'stretch',
  };
}

export function webColumnStyle(maxWidth?: number): ViewStyle {
  return {
    flex: 1,
    width: '100%',
    minHeight: 0,
    minWidth: 0,
    alignSelf: 'center',
    ...(maxWidth != null ? { maxWidth } : null),
  };
}

export function webScrollStyle(): ViewStyle {
  return {
    flex: 1,
    minHeight: 0,
    width: '100%',
    overflow: 'scroll',
  };
}

export const webModalOverlay: ViewStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  padding: spacing.xl,
};

export const webModalCard: ViewStyle = {
  width: '100%',
  maxWidth: layout.webModalMaxWidth,
  maxHeight: '90%',
  borderRadius: 16,
};

export const webDialogOverlay: ViewStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  padding: spacing.xl,
  backgroundColor: 'rgba(15, 23, 42, 0.45)',
};

export const webDialogCard: ViewStyle = {
  width: '100%',
  maxWidth: layout.webDialogMaxWidth,
  height: '90%',
  maxHeight: 820,
  borderRadius: 16,
  overflow: 'hidden',
};
